import investsaudihomepg from "../../Images/invest-saudi-HomePg.webp";
import { ReactComponent as Horizontal } from "../../Images/horizontal.svg";
import { ReactComponent as Veriticle } from "../../Images/vertical.svg";
import homeclient1 from "../../Images/home-client-1.png";
import homeclient2 from "../../Images/home-client-2.png";
import homeclient3 from "../../Images/home-client-3.png";
import homeclient4 from "../../Images/home-client-4.png";
import homeclient5 from "../../Images/home-client-5.png";
import homeclient6 from "../../Images/home-client-6.png";
import homeclient7 from "../../Images/home-client-7.png";
import homeclient8 from "../../Images/home-client-8.png";
import homeclient9 from "../../Images/home-client-9.png";

import "../.././App.css";

const SaudiInvestmentSections = () => {
  return (
    <div className="relative min-h-screen w-full">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-top bg-no-repeat"
        style={{
          backgroundImage: `url(${investsaudihomepg})`,
        }}
      >
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        {/* Why Invest in Saudi Arabia Section */}
        <section className="container mx-auto px-4 py-16 md:py-24">
          {/* Header */}
          <div className="text-center mb-12 md:mb-20">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
              Why Invest in Saudi Arabia?
            </h1>
            <p className="text-lg md:text-xl text-gray-200 max-w-4xl mx-auto leading-relaxed">
              Saudi Arabia stands at the epicenter of economic transformation in
              the Middle East, presenting investors with unparalleled
              opportunities
            </p>
          </div>
          <div className="flex justify-center" data-aos="fade-up">
            <div className="w-full h-auto block md:hidden">
              <Veriticle />
            </div>
            <div className="w-full h-[350px] hidden md:block">
              <Horizontal />
            </div>
          </div>
        </section>

        {/* Our Clients Section */}
        <section className="container mx-auto px-4 py-16 md:py-24 overflow-hidden">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
              Our Clients
            </h2>
            <p className="text-lg md:text-xl text-gray-200">
              We have been working with some Fortune 500+ clients
            </p>
          </div>

          <div className="relative w-full overflow-hidden">
            <div
              className="inline-flex animate-scroll whitespace-nowrap gap-12"
              style={{ width: "max-content" }}
            >
              {[...Array(2)]
                .flatMap(() => [
                  homeclient1,
                  homeclient2,
                  homeclient3,
                  homeclient4,
                  homeclient5,
                  homeclient6,
                  homeclient7,
                  homeclient8,
                  homeclient9,
                ])
                .map((src, index) => (
                  <div
                    key={index}
                    className="flex-shrink-0 w-40 h-24 flex items-center justify-center"
                  >
                    <img
                      src={src}
                      alt={`client-${index}`}
                      className="max-h-full max-w-full object-contain"
                    />
                  </div>
                ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SaudiInvestmentSections;
